import React from 'react'

export default function NewsMediaScreen() {
    return (
        <div>NewsMediaScreen</div>
    )
}
